import React, { useEffect, useState } from 'react';
import { loadAnalytics } from '../utils/analytics';
import styles from './styles/AnalyticsConsent.module.css';

const CONSENT_KEY = 'fgv:analytics-consent';
type Consent = 'accepted' | 'rejected' | null;

const scheduleAnalytics = () => {
  const start = () => window.setTimeout(loadAnalytics, 1200);
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
};

const AnalyticsConsent: React.FC = () => {
  const [consent, setConsent] = useState<Consent>(() => {
    const stored = window.localStorage.getItem(CONSENT_KEY);
    return stored === 'accepted' || stored === 'rejected' ? stored : null;
  });

  useEffect(() => {
    if (consent === 'accepted') scheduleAnalytics();
  }, [consent]);

  const choose = (value: Exclude<Consent, null>) => {
    window.localStorage.setItem(CONSENT_KEY, value);
    setConsent(value);
  };

  if (consent) return null;

  return (
    <aside className={styles.banner} aria-label="Preferencias de medición">
      <p>
        Usamos medición anónima para entender cómo mejorar el sitio. Solo se activa si aceptás.
      </p>
      <div className={styles.actions}>
        <button type="button" className={styles.secondary} onClick={() => choose('rejected')}>
          Rechazar
        </button>
        <button type="button" className={styles.primary} onClick={() => choose('accepted')}>
          Aceptar
        </button>
      </div>
    </aside>
  );
};

export default AnalyticsConsent;
